import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_AUDIO_SETTINGS_VISIBILITY, SET_USER_INFO, SET_VIDEO_SETTINGS_VISIBILITY } from './actionTypes';
ReducerRegistry.register('features/settings', (state = {}, action) => {
    switch (action.type) {
        case SET_USER_INFO: {
            return Object.assign(Object.assign({}, state), { user: Object.assign({}, action.value) });
        }
        case 'SET_CALLING_DIALOG': {
            return Object.assign(Object.assign({}, state), { callDialog: action.show });
        }
        case 'SET_CALLING_INFO': {
            return Object.assign(Object.assign({}, state), { callInfo: action.info });
        }
        case 'SET_SCHEDULE_CALL_DIALOG': {
            return Object.assign(Object.assign({}, state), { scheduleCallDialog: action.show });
        }
        case 'SET_SCHEDULE_CALL_INFO': {
            return Object.assign(Object.assign({}, state), { scheduleCallInfo: action.info });
        }
        case 'USER_CONTACT': {
            return Object.assign(Object.assign({}, state), { contact: action.value });
        }
        case 'SET_KEEP_DND': {
            return Object.assign(Object.assign({}, state), { isKeepDnd: action.value });
        }
        case SET_AUDIO_SETTINGS_VISIBILITY:
            return Object.assign(Object.assign({}, state), { audioSettingsVisible: action.value });
        case SET_VIDEO_SETTINGS_VISIBILITY:
            return Object.assign(Object.assign({}, state), { videoSettingsVisible: action.value });
    }
    return state;
});
